export default {
    tip: 'If the user is not found, please click the "New" button on the right.',
    no_selected: 'You have not selected an author yet.',
    batch_live_title: 'Batch set live notes',
    batch_live_note_warning: 'Note: If none of the three items are selected, the live notes of all sessions under the meeting will be updated!!!',
    batch_live_label_date: 'Date',
    batch_live_label_hall: 'Venue',
    batch_live_label_xuezu: 'Special forum',
    batch_live_label_live_notes: 'Live notes',
    title: 'Title',
    batch_modify: 'Batch modify',
    session_name: 'Session name',
    time_period: 'Time period',
    batch_edit: 'Batch edit',
    no_select_not_update: 'Not selecting means no update.',
    cn_website_display_mode: 'Chinese website display mode',
    en_website_display_mode: 'English website display mode',
    edit_unit: 'Edit unit',
    meeting_schedule_management: 'Meeting schedule management',
    export_session: 'Export Session schedule',
    topic_forum: 'Belongs to the special forum:',
    delete_session: 'Are you sure you want to delete the session [{session}]?',
    meeting_session_management: 'Meeting schedule management',
    edit_session: 'Edit Session',
    add_chair_host_translator_chinese: 'Add chair/host/translator (Chinese guests)',
    add_chair_host_translator_foreign: 'Add chair/host/translator (Foreign guests)',
    host: 'Host',
    chinese_guest: 'Chinese guest',
    foreign_guest: 'Foreign guest',
    view_conflict: 'View conflict',
    translator: 'Translator',
    time_linkage_checkbox: 'When the end time of the current item is less than the start time of the next item, whether the subsequent time periods are linked',
    add_topic_speaker_chinese: 'Add topic speaker (Chinese guests)',
    add_topic_speaker_foreign: 'Add topic speaker (Foreign guests)',
    add_discussion_etc: 'Add discussion/debate/others',
    start_time_placeholder: 'Start time',
    end_time_placeholder: 'End time',
    add_host_chinese: 'Add host (Chinese guests)',
    add_host_foreign: 'Add host (Foreign guests)',
    upload_video: 'Upload video',
    edit: 'Edit',
    batch_save: 'Batch save',
    sorting: 'Sorting',
    start_time: 'Start time',
    end_time: 'End time',
    duration_minutes: 'Duration (minutes)',
    type: 'Type',
    task_allocation: 'Task allocation',
    question: 'Question',
    modify_topic_forum: 'Modify special forum',
    add_topic_forum: 'Add special forum',
    cn_name: 'Chinese name',
    en_name: 'English name',
    meeting_date: 'Meeting date',
    current_date_color: 'Schedule color of the current date',
    schedule_color: 'Schedule color',
    export_program: 'Export schedule',
    select_export_date: 'Select export date',
    select_export_hall: 'Select export venue',
    select_export_special_forum: 'Select export special forum',
    show_host_unit: "Whether to show the host's unit",
    show_speaker_unit: "Whether to show the speaker's unit",
    show_speech_type: 'Whether to show the speech type',
    show_country: 'Whether to show the country',
    show_chinese_english: 'Whether to show Chinese and English',
    show_all: 'Show all',
    show_chinese_only: 'Show Chinese only',
    show_english_only: 'Show English only',
    show_paper_number: 'Whether to show the paper number',
    show_paper_number_text: 'Show paper number',
    show_serial_number: 'Show serial number',
    show_hidden_schedule: 'Whether to show hidden schedules',
    export_program_word: 'Export schedule in Word format',
    export_program_excel: 'Export schedule in Excel format',
    update_hall: 'Modify venue',
    add_hall: 'Add venue',
    hall_cn_name_placeholder: 'Please enter the Chinese name of the venue',
    hall_en_name_placeholder: 'Please enter the English name of the venue',
    hall_login_account: 'Venue login account (Online version of the slide system)',
    hall_login_account_placeholder: 'Please enter the venue login account',
    hall_login_password: 'Venue login password (Online version of the slide system)',
    hall_login_password_placeholder: 'Please enter the venue login password',
    hall_ad_open: 'Whether to turn on off - site advertising',
    hall_computer_ip: 'Venue computer IP',
    hall_computer_ip_placeholder: 'Please enter the venue computer IP',
    hall_sorting_placeholder: 'Please enter the sorting',
    hall_remarks_placeholder: 'Please enter remarks',
    program_logs_title: 'Academic schedule update log',
    query_start_date: 'Query start date',
    start_date_placeholder: 'Start date',
    query_end_date: 'Query end date',
    end_date_placeholder: 'End date',
    table_column_id: 'Number',
    table_column_notice: 'Update description',
    table_column_create_time: 'Update time',
    table_column_name: 'Operator',
    repeat_list_drawer_title: 'Automatic schedule duplicate checking',
    repeat_list_drawer_date_conflict_title: 'Schedule time conflict',
    repeat_list_drawer_fayan_conflict_title: 'Multiple speeches of the same paper',
    repeat_list_drawer_edit_unit: 'Unit edit',
    task: 'Task',
    theme: 'Theme',
    abstract_id: 'Paper ID',
    unit: 'Unit',
    modify_task: 'Modify task',
    basic_info: 'Basic information',
    participation_form: 'Participation form',
    recorded_broadcast: 'Recorded broadcast',
    online_connection: 'Online connection',
    on_site_participation: 'On - site participation',
    topic_speaker_info: 'Topic speaker information',
    query_author: 'Query author',
    service_fee: 'Service fee',
    has_service_fee: 'Whether there is a service fee',
    currency: 'Currency',
    service_fee_amount: 'Service fee amount',
    please_fill_service_fee_amount: 'Please fill in the service fee amount',
    role_task: 'Role task',
    person_in_charge: 'Person in charge',
    add_academic_unit: 'Add academic unit',
    single_schedule_duration: 'Single schedule duration (minutes)',
    change_single_schedule_duration: 'Whether to change the single schedule duration',
    unit_chinese_title: 'Unit Chinese title',
    unit_english_title: 'Unit English title',
    session_introduction_cn: 'Session introduction in Chinese',
    session_introduction_en: 'Session introduction in English',
    unit_color: 'Unit color',
    is_satellite_tip: 'After enabling, it can be displayed on the special session tab of the live page.',
    is_sync_program_tip: 'After turning off, it will not be synchronized to the slide system.',
    live_source_tip: 'Controls the display of the "Watch live" button on the schedule page.',
    default_hall_config: 'Default venue configuration: Call the live broadcast associated with the venue',
    system_table_live: 'System table live broadcast: Select the associated system live broadcast',
    third_party_live: 'Third - party platform live broadcast: Enter the third - party platform link to call and jump to the third - party platform address',
    select_associated_live: 'Select associated live broadcast',
    session_label: 'Session label',
    session_label_tip: 'Used to display after the Session title on the PC and mobile schedule',
    session_contact: 'Session contact person',
    session_contact_tel: "Session contact person's phone number",
    satellite_display_image: 'Special session display image',
    satellite_display_image_tip: 'Recommended size: 950*150px, supports JPG, GIF, PNG image files, file size: ≤500kb',
    satellite_display_image_usage: 'Used for the special session tab display on the live page',
    satellite_company_logo: 'Special session company logo',
    upload_image: 'Upload image',
    label_xuezu: 'Sub - forum',
    unplanned_list_drawer_title: 'Articles that have been reviewed but not included in the schedule',
    batch_remove: 'Batch delete',
    real_name: 'Author',
    typename_cn: 'Acceptance type',
    unplanned_members_drawer_title: 'View the list of committee members without assigned academic tasks',
    select_branch: 'Select branch',
    please_select: 'Please select',
    click_to_view: 'Click to view',
    keyword: 'Keyword',
    name_phone_email: 'Name/Phone number/Email',
    task_allocation_label: 'Task arrangement',
    arranged: 'Arranged',
    unarranged: 'Unarranged',
    search: 'Search',
    committee_task_allocation: 'Committee member task arrangement: Arranged',
    people: ' people, Unarranged',
    export_unplanned_members_list: 'Export the list of committee members without assigned academic tasks',
    user_id: 'User ID',
    position: 'Position',
    please_select_branch: 'Please select a branch first',
    name: 'Name',
    organization: 'Organization',
    title_search: 'Title search',
    speech_type: 'Speech type',
    search_button: 'Search',
    date_label: 'Date',
    add_date_button: 'Add date',
    all_option: 'All',
    hall_label: 'Venue',
    add_hall_button: 'Add venue',
    special_forum_label: 'Special forum',
    add_special_forum_button: 'Add special forum',
    hall_date_header: 'Venue/Date',
    quick_switch_hall: 'Quick switch venue',
    add_academic_unit_button: 'Add academic unit',
    edit_date_modal: 'Edit date pop - up window',
    edit_special_forum_modal: 'Edit special forum pop - up window',
    edit_hall_modal: 'Edit venue pop - up window',
    repeat_list_drawer: 'Schedule time conflict duplicate checking',
    child_session_drawer: 'Sub - session',
    edit_session_drawer: 'Edit schedule',
    unplanned_list_drawer: 'Articles that have been reviewed but not included in the schedule',
    export_program_modal: 'Export schedule',
    program_logs_drawer: 'View schedule update records',
    batch_live_modal: 'Batch set live notes',
    batch_session_drawer: 'Batch modify Session information',
    unplanned_members_drawer: 'View the list of committee members without assigned academic tasks',
    upload_video_drawer: 'Video upload management',
    all_units: 'All units',
    add_unit: 'Add unit',
    view_program_cn: 'View schedule (Chinese page)',
    view_program_en: 'View schedule (English page)',
    clear_cache: 'Clear schedule cache',
    more_operations: 'More operations',
    sort_success: 'Sorting succeeded',
    back_to_schedule_list: 'Back to schedule list',
    view_session: 'View this Session',
    role: 'Role',
    sorting_tip: 'The smaller the serial number, the more forward it is.',
    hall_type: 'Venue type',
    chinese_hall: 'Chinese venue',
    english_hall: 'English venue',
    is_satellite: 'Whether it is a special session',
    is_sync_program: 'Whether to synchronize to the on - site schedule',
    live_source: 'Live source',
    abstract_type: 'Optional paper category',
    forum_info: 'Sub - forum information',

    add_title_tips: 'Note: Please directly search for the manuscript title. Add a new one if not found.',
    p_duration_minutes: 'Please enter the duration (minutes)',
    meeting_type: 'Meeting form',
    p_meeting_type: 'Please select the meeting form',
    meeting_type1: 'Recorded broadcast',
    meeting_type2: 'Online connection',
    meeting_type3: 'On - site participation',
    meeting_type4: 'Undetermined',
    p_has_service_fee: 'Please select whether there is a service fee',
    p_currency: 'Please select the currency',
    add_title_search: 'Title/ID search',
    p_add_title_search: 'Please enter the title/ID for search',

    // The following is the language package for the program - config related pages automatically extracted
    speak_config_add: 'New',
    speak_config_table: 'Table',
    drag_sort: 'Sorting',
    chinese_name: 'Chinese name',
    english_name: 'English name',
    status: 'Status',
    role: 'Role',
    operation: 'Operation',
    confirm_delete_category: 'Are you sure you want to delete this category?',
    delete_success: 'Deletion succeeded',
    open: 'Open',
    close: 'Close',
    limit_config_id: 'Configuration ID',
    limit_period: 'Limit period',
    limit_roles: 'Limit roles',
    limit_times: 'Limit the number of times to add personnel',
    limit_edit_times: 'Limit the number of times to add',
    all: 'All',
    every_day: 'Every day',
    host_type: 'Host type',
    discuss_type: 'Discussion type',
    speaker_type: 'Speaker type',
    host_and_discuss: 'Host and discussion type',
    slide_admin: 'Slide administrator',
    slide_admin_manage: 'Management of the trial room client administrator',
    slide_download: 'Slide client download',
    click_download: 'Click to download',
    bold_name: 'Whether to enable bold font for names',
    choose_bold_name: 'Please choose whether to enable bold font for names',
    font_color: 'Font color setting',
    upload_image: 'Upload image',
    upload_cover: 'Please upload the cover image',
    suggest_size: 'Recommended size: 1280*720px, supports JPG, PNG image files, maximum image size: 2M',
    slide_background: 'Live background image',
    meeting_notice: 'Venue notice',
    upload_file: 'Upload file',
    view_file: 'View',
    please_upload_meeting_notice: 'Please upload the venue meeting notice',
    only_pps: 'Only .pps type files can be uploaded',
    open_speaker_upload: "Whether to enable the function of uploading speakers' PPTs on the front - end",
    choose_open_speaker_upload: "Please choose whether to enable the function of uploading speakers' PPTs on the front - end",
    file_version_type: 'Collected file version type',
    choose_file_version_type: 'Please choose the collected file version type',
    open_slide_audit: 'Whether to enable the review of PPTs uploaded for special sessions',
    choose_open_slide_audit: 'Please choose whether to enable the review of PPTs uploaded for special sessions',
    speaker_upload_deadline: "Deadline for uploading speakers' PPTs on the front - end",
    choose_speaker_upload_deadline: "Please choose the deadline for uploading speakers' PPTs on the front - end",
    cut_content_cn: 'Prompt content after the deadline (Chinese)',
    cut_content_en: 'Prompt content after the deadline (English)',
    live_mode: 'Live mode',
    choose_live_mode: 'Please choose the live mode',
    three_screen: 'Triple - screen',
    ppt: 'PPT',
    open_cloud_record: 'Whether to enable cloud recording',
    choose_open_cloud_record: 'Please choose whether to enable cloud recording',
    cloud_record_schedule: 'Cloud recording associated schedule',
    choose_cloud_record_schedule: 'Please choose the cloud recording associated schedule',
    cloud_record_mode: 'Cloud recording mode',
    choose_cloud_record_mode: 'Please choose the cloud recording mode',
    view_local_video: 'View the list of locally recorded videos',
    view_cloud_video: 'View the list of cloud - recorded videos',
    save: 'Save',
    local_video: 'Locally recorded video',
    video_name: 'Video name',
    file_size: 'File size',
    upload_time: 'Upload time',
    view: 'View',
    slide_user_admin: 'Trial room administrator',
    login_account: 'Login account',
    please_enter_login_account: 'Please enter the login account',
    login_password: 'Login password',
    please_enter_login_password: 'Please enter the login password',
    subscribe_record: 'Subscription record',
    session_title: 'Session title',
    user_name: 'User name',
    subscribe_time: 'Subscription time',
    message_type: 'Message type',
    send_content: 'Send content',
    message_create_time: 'Message creation time',
    receiver: 'Receiver',
    receiver_phone: "Receiver's phone number",
    send_status: 'Send status',
    send_time: 'Send time',
    send_success: 'Send succeeded',
    not_sent: 'Not sent',
    send_failed: 'Send failed',
    show_status: 'Display status',
    show: 'Show',
    hide: 'Hide',
    please_choose_show_status: 'Please choose the display status',
    please_enter_chinese_name: 'Please enter the Chinese name',
    please_enter_english_name: 'Please enter the English name',
    role_type: 'Role type',
    please_choose_role_type: 'Please choose the role type',
    comment: 'Comment',
    discuss: 'Discussion',
    judge: 'Judge',
    guest: 'Guest',
    host: 'Host',
    chairman: 'Chairman',
    translator: 'Translator',
    speaker: 'Speaker',
    operator: 'Operator',
    please_enter_limit_period: 'Please enter the limit period',
    please_choose_limit_roles: 'Please choose the limit roles',
    please_enter_limit_times: 'Please enter the limit number of times to add',
    roles1: 'All',
    roles2: 'Host type',
    roles3: 'Discussion type',
    roles4: 'Speaker type',
    pcProgramList1: 'Schedule template one',
    pcProgramList2: 'Schedule template two',
    choose_is_to_externally: 'Please choose whether the schedule is externally displayed',
    is_to_externally: 'Whether the schedule is externally displayed',
    program_abs_title_type: 'Required rule for the schedule paper title',
    choose_program_abs_title_type: 'Please choose the required rule for the schedule paper title',
    chinese_required: 'Chinese is required',
    english_required: 'English is required',
    chinese_and_english_required: 'Both Chinese and English are required',
    chinese_and_english_only_one_required: 'Only one of Chinese and English needs to be filled',
    page_color_setting: 'Schedule page color setting',
    pc_program_template: 'PC - side schedule template',
    pc_program_template_selection: 'PC - side schedule template selection',
    pc_program_list_template_selection: 'PC - side schedule list template selection',
    pc_speaker_list_template_selection: 'PC - side speaker list template selection',
    mobile_program_template: 'Mobile - side schedule template',
    mobile_program_template_selection: 'Mobile - side schedule template selection',
    mobile_program_list_template_selection: 'Mobile - side schedule list template selection',
    mobile_speaker_list_template_selection: 'Mobile - side speaker list template selection',
    select_program_content_to_display: 'Please choose the content to be displayed on the schedule page',
    whether_to_display_serial_number: 'Whether to display the serial number',
    choose_whether_to_display_serial_number: 'Please choose whether to display the serial number',
    display_paper_serial_number: 'Display paper serial number',
    display_serial_number: 'Display serial number',
    do_not_display_serial_number: 'Do not display the serial number',
    program_display_order: 'Schedule display order',
    choose_program_display_order: 'Please choose the schedule display order',
    display_by_hall_order: 'Display in venue order',
    display_by_date_order: 'Display in date order',
    display_by_forum: 'Display by sub - forum',
    whether_to_display_chinese_and_english: 'Whether to display Chinese and English',
    choose_whether_to_display_chinese_and_english: 'Please choose whether to display Chinese and English',
    display_all: 'Display all',
    display_only_chinese: 'Display Chinese only',
    display_only_english: 'Display English only',
    whether_to_display_english_page_local_time: 'Whether to display Local Time on the English page',
    choose_whether_to_display_english_page_local_time: 'Please choose whether to display Local Time on the English page',
    speaker_host_configuration: 'Speaker and host configuration',
    speaker_host_list_display_order: 'Speaker and host list display order',
    choose_speaker_host_list_display_order: 'Please choose the speaker and host configuration',
    sort_by_pinyin_order: 'Sort in alphabetical order of names',
    sort_by_program_order: 'Sort in schedule appearance order',
    whether_to_display_avatar: 'Whether to display the avatar',
    choose_whether_to_display_avatar: 'Please choose whether to display the avatar',
    whether_to_display_personal_introduction: 'Whether to display the personal introduction',
    choose_whether_to_display_personal_introduction: 'Please choose whether to display the personal introduction',
    whether_to_display_speaker_host_query_page_statistics: 'Whether to display the statistics on the speaker and host query page',
    choose_whether_to_display_speaker_host_query_page_statistics: 'Please choose whether to display the statistics on the speaker and host query page',
    whether_to_display_acceptance_state_in_backend_program_management_page: 'Whether to display the acceptance state on the backend schedule management page',
    choose_whether_to_display_acceptance_state_in_backend_program_management_page: 'Please choose whether to display the acceptance state on the backend schedule management page',
    whether_to_allow_experts_to_jump_to_expert_personal_center_from_conference_program_details:
        "Whether to allow clicking on the expert's name in the conference schedule details to jump to the expert's personal center",
    choose_whether_to_allow_experts_to_jump_to_expert_personal_center_from_conference_program_details:
        "Please choose whether to allow clicking on the expert's name in the conference schedule details to jump to the expert's personal center",
    whether_to_enable_academic_task_sheet_download: 'Whether to enable the download of the academic task sheet',
    choose_whether_to_enable_academic_task_sheet_download: 'Please choose whether to enable the download of the academic task sheet',
    whether_to_include_system_hidden_session_program_in_academic_task_confirmation_and_sms_email_reminder:
        'Whether to include the system - hidden SESSION schedules in the personal academic task confirmation and SMS/email reminders',
    view_sms_send_recordchoose_whether_to_include_system_hidden_session_program_in_academic_task_confirmation_and_sms_email_reminder:
        'Please choose whether to include the system - hidden SESSION schedules in the personal academic task confirmation and SMS/email reminders',
    session_subscription: 'Session subscription',
    view_session_subscription_record: 'View Session subscription records',
    whether_to_session_subscription: 'Whether to subscribe to Sessions',
    choose_whether_to_session_subscription: 'Please choose whether to subscribe to Sessions',
    whether_to_send_reminder_sms: 'Whether to send reminder SMS',
    choose_whether_to_send_reminder_sms: 'Please choose whether to send reminder SMS',
    this_function_will_deduct_meeting_creator_sms_balance:
        "This function will deduct the meeting creator's SMS sending balance. The reminded schedules must be within the current meeting configuration range. The push tasks will be generated in advance. If you need to test, please add five minutes to the start time to avoid test failure due to the test time being too close.",
    conference_representative_session_reminder_send_time: "Reminder sending time for conference representatives' Sessions",
    before_program_start: 'Before the schedule starts',
    please_enter_conference_representative_session_reminder_send_time: "Please enter the reminder sending time for conference representatives' Sessions",
    minutes_before_sending_reminder: ' minutes before sending the reminder',
    view_sms_send_record: 'View SMS sending records',
    conference_representative_session_reminder_content: "Reminder content for conference representatives' Sessions",
    conference_representative_name: "Conference representative's name",
    speaker_name: "Speaker's name",
    speech_title: 'Speech title',
    speech_time: 'Speech time',
    meeting_hall: 'Venue name',
    please_choose_conference_representative_session_reminder_content: "Please choose the reminder content for conference representatives' Sessions",
    the_longest_character_length_of_a_single_sms_content_is_500_characters: 'The maximum character length of a single SMS content is 500 characters.',
    program_subscription: 'Schedule subscription',
    view_program_subscription_record: 'View schedule subscription records',
    whether_to_program_subscription: 'Whether to subscribe to schedules',
    choose_whether_to_program_subscription: 'Please choose whether to subscribe to schedules',
    conference_representative_program_reminder_send_time: "Reminder sending time for conference representatives' schedules",
    host_and_speaker_program_reminder: "Reminders for hosts and speakers' schedules",
    whether_to_enable_host_and_speaker_program_reminder: "Whether to enable reminders for hosts and speakers' schedules",
    choose_whether_to_enable_host_and_speaker_program_reminder: "Please choose whether to enable reminders for hosts and speakers' schedules",
    send_sms_history: 'SMS sending history',
    forum: 'Sub - forum',
    copy: 'Copy',
    monolingual: 'Monolingual',
    bilingual: 'Bilingual',
    cut_content_example1: 'Example: The collection of online courseware for this meeting has ended! You can upload it at the venue:',
    cut_content_example2: 'Trial room location: Room XXX, Hall A, XX Exhibition Center',
    cut_content_example3: 'Trial room working hours:',
    cut_content_example4: 'November 16th, 13:00 - 19:00',
    cut_content_example5: 'November 17th, 07:15 - 17:30',
    cut_content_example6: 'November 18th, 07:30 - 17:30',
    cut_content_example7: 'November 19th, 07:30 - 11:00',
    view_local_video_list: 'View the list of locally recorded videos',
    cloud_record_unit_no: 'Unit No',
    cloud_record_unit_yes: 'Unit Yes',
    view_cloud_video_list: 'View the list of cloud - recorded videos',
    program_name: 'Associated schedule',
    related_video: 'Associated video',
    recording_task_status: 'Recording task status',
    whether_upload_to_vod: 'Whether to upload to VOD',
    upload_success: 'Upload succeeded',
    recording: 'Recording',
    all: 'All',
    not_transcoded: 'Not transcoded',
    transcoding: 'Transcoding',
    upload_failed: 'Upload failed',
    sync_cloud_video_to_vod: 'Synchronize cloud - recorded videos to VOD',
    number: 'Serial number',
    add_task: {
        title: 'Add task',
        update_title: 'Modify task',
        attendance_info: 'Attendance information',
        date: 'Date',
        hall: 'Venue',
        session: 'Session',
        please_select_date: 'Please select the date',
        please_select_hall: 'Please select the venue',
        please_select_session: 'Please select the Session',
        attending_by: 'Attendance form',
        please_select_attending_by: 'Please select the attendance form',
        live_streaming_link: 'Live streaming link',
        please_add_user_info: 'Please add user information first',
        honorarium_info: 'Honorarium information',
        whether_to_pay: 'Whether there is an honorarium',
        yes: 'Yes',
        no: 'No',
        currency_type: 'Currency type',
        please_select_currency_type: 'Please select the currency type',
        service_fee_amount: 'Service fee amount',
        please_input_service_fee_amount: 'Please enter the service fee amount',
        role_task_info: 'Role task information',
        role_task: 'Role task',
        please_select_role_task: 'Please select the role task',
        responsible_person: 'Responsible person information',
        responsible: 'Responsible person',
        remarks_admin: 'Remarks',
        save: 'Save',
        save_and_continue: 'Save and continue',
        operation_success: 'Operation succeeded'
    },
    repeat_list_modal: {
        title: 'Repeat task list',
        current_task: 'Current task',
        name: 'Name',
        org_cnname: 'Organization',
        date: 'Date',
        hall: 'Venue',
        session: 'Session',
        task: 'Task',
        abstract_title: 'Paper title',
        time: 'Time',
        abstract_title: 'Theme'
    },
    upload_related_video: {
        title: 'Upload video',
        related_type: 'Association method',
        related_type_1: 'New video',
        related_type_2: 'Associate with video resource library',
        video_name: 'Video name',
        video_name_required: 'Please enter the video name',
        please_upload_video: 'Please upload the video',
        video_size_limit: 'Video size cannot exceed 500M. Supported video formats: *.avi; *.wmv; *.mp4;*.mov; *.flv; *.mkv; *.rmvb',
        video_format: 'Supported video formats: *.avi; *.wmv; *.mp4;*.mov; *.flv; *.mkv; *.rmvb',
        live_id: 'Associated live broadcast',
        is_online: 'Whether to display on the learning platform/live replay',
        please_select: 'Please select',
        click: 'Please click to search. Do not add new ones easily.',
        author_list: 'Associated author list',
        please_select_author_list: 'Please select the associated author list',
        author_list_tip: 'The larger the sorting serial number, the more forward it is.',
        delete: 'Delete',
        cover_image: 'Video cover',
        please_upload_cover_image: 'Please upload the video cover',
        upload_img: 'Upload image',
        upload_img_tip: 'Recommended size: 1280*720px, supports JPG, GIF, PNG image files',
        sorting: 'Sorting',
        sorting_tip: 'The larger the sorting, the more forward it is.',
        intro: 'Video introduction',
        related_video: 'Associated video',
        video_is_display: 'Whether to display in the schedule',
        authorization_state: 'Video authorization:',
        authorization_state_live: 'Live broadcast authorization:',
        cancel_related_video: 'Cancel associated video',
        save: 'Save',
        user_id: 'User ID',
        author_name: 'Author name',
        author_org: "Author's organization",
        action: 'Action',
        save_success: 'Save succeeded',
        limit_number: 'File size cannot exceed 500MB!',
        upload_type: 'Please upload files in the format of {type}',
        agree: 'Agree',
        refuse: 'Refuse',
        un_confirm: 'Unconfirmed',
        confirm_cancel: 'Are you sure you want to cancel the associated video?',
        cancel_success: 'Cancellation succeeded'
    },
    batch_add_program_modal: {
        title: 'Batch add paper schedules',
        abstract_ids: 'Paper numbers',
        please_input: 'Please enter',
        please_input_abstract_ids: 'Please enter the paper numbers',
        input_abstract_ids_tip: 'Please enter the paper numbers you want to add in batches. Separate multiple papers with line breaks.',
        speaker_type: 'Topic speaker type',
        please_select_speaker_type: 'Please select the topic speaker type',
        speaker_type_cn: 'Chinese topic speaker',
        speaker_type_en: 'Foreign topic speaker',
        minutes: 'Minutes for each schedule task',
        please_input_minutes: 'Please enter the minutes for each schedule task',
        reg: 'For example: 15',
        add_success: 'Addition succeeded'
    },
    import_program_details_drawer: {
        title: 'Schedule import details',
        date: 'Date',
        speaker: 'Speaker',
        time_range: 'Time range',
        venue: 'Venue',
        status: 'Status',
        status_1: 'Imported',
        save: 'Save',
        name: 'Name',
        unit: 'Organization',
        phone: 'Phone number',
        email: 'Email',
        remark: 'Remarks',
        abstract_title: 'Paper title',
        abstract_id: 'Paper number',
        abstract_type: 'Paper category',
        duration: 'Duration',
        type: 'Speech type',
        title: 'Title',
        article_id: 'Article ID number',
        checking: 'Checking',
        check_data_integrity: 'Check data integrity',
        confirm_import: 'Confirm import',
        import: 'Importing',
        reupload: 'Re - upload',
        deleted: 'Deleted',
        waiting_for_verification: 'Waiting for verification',
        waiting_for_import: 'Waiting for import',
        importing: 'Importing',
        import_success: 'Import succeeded',
        import_failed: 'Import failed',
        check_failed: 'Check failed',
        new_import_task: 'New import task',
        upload_file: 'Upload file',
        please_upload_file: 'Please upload the import data',
        upload_data: 'Upload import data',
        upload_tips: 'Please upload files with the suffix .xlsx',
        download_template: 'Download import template',
        download_instructions: 'Download operation instructions',
        add_success: 'Addition succeeded',
        limit_500: 'File size cannot exceed 500MB!',
        import_title: 'Schedule import',
        refresh: 'Refresh',
        add_import_task: 'New import task',
        view_details: 'View details',
        task_id: 'Task ID',
        task_status: 'Task status',
        create_time: 'Creation time',
        update_time: 'Update time',
        actions: 'Actions'
    },
    search_user: {
        title: 'Search by phone number/name:',
        placeholder: 'Phone number/Name',
        please_input: 'Please enter',
        please_input_name: 'Please enter the phone number/name',
        please_input_org_name: 'Organization name (Optional)',
        please_input_email: 'Please enter the email',
        search_btn: 'Search',
        task_num: '[There are { count } tasks]',
        attend_meeting: '[Already participated in the meeting] |',
        selected: 'Selected',
        select: 'Select',
        task_type: 'Task type',
        task_num: 'Task quantity',
        no_result: 'If the user is not found, please click',
        new: 'New',
        user_id: 'User ID',
        name: 'Chinese name',
        xing: 'Pinyin of the surname',
        please_input_xing: 'Please enter the pinyin of the surname',
        ming: 'Pinyin of the given name',
        please_input_ming: 'Please enter the pinyin of the given name',
        abbreviation: 'Initial abbreviation of the name',
        please_input_abbreviation: 'Please enter the initial abbreviation of the name',
        reg: 'Used when sorting the speaker and host list in alphabetical order of names. Please fill in the initials of the name. For example, if the name is Wang Yiyi, fill in wyy.',
        country: 'Country',
        region: 'Region',
        org_cnname: 'Organization',
        please_input_org_cnname: 'Please enter the organization',
        org_enname: 'English organization',
        please_input_org_enname: 'Please enter the English organization',
        department: 'Department',
        please_input_department: 'Please enter the department',
        address: 'Mailing address',
        please_input_address: 'Please enter the mailing address',
        phone: 'Mobile phone number',
        please_input_phone: 'Please enter the mobile phone number',
        phone_format_error: 'The mobile phone number format is incorrect',
        tel_no: 'Telephone number',
        zipcode: 'Zip code',
        please_input_zipcode: 'Please enter the zip code',
        email: 'Email',
        please_input_email: 'Please enter the email',
        org_cnname_d: 'Chinese organization displayed in the schedule',
        org_enname_d: 'English organization displayed in the schedule',
        only_fill_when_different: "Only fill in when the organization displayed in the schedule is different from the user's organization. If they are the same, no need to fill in.",
        post_name: 'Position',
        new_user_title: 'New user',
        real_name: 'Name',
        please_input_real_name: 'Please enter the name',
        org_cnname: 'Organization',
        member: 'Committee',
        sequence: 'Session',
        xzname: 'Appointment institution',
        post: 'Position',
        begin_time: 'Appointment start time',
        end_time: 'Appointment end time',
        date: 'Date',
        hall: 'Venue',
        task: 'Task',
        new_success: 'New addition succeeded',
        has_exist: 'The account already exists. Do not add it repeatedly.',
        please_input_real_name: 'Please fill in the Chinese name'
    },
    batch_add_program_by_abstract_ids: 'Batch add schedules according to paper numbers',
    add_task_cn: 'Add task (Chinese guests)',
    add_task_en: 'Add task (Foreign guests)',
    add_sub_topic: 'Add sub - topic',
    delete_program: 'Are you sure you want to delete this schedule?',
    delete_task: 'Are you sure you want to delete this task?',
    import_program: 'Schedule import',
    changeProgram: 'Modify schedule',
    session_info: 'Session information',
    add_title: 'Add topic speaker',
    title_speaker: 'Topic speaker',
    add_title_speaker_tips:
        'Note: When modifying the schedule, directly modifying the title will also change the corresponding manuscript title. If you need to replace the manuscript, please search directly.',
    cn_title: 'Chinese title',
    p_cn_title: 'Please enter the Chinese title',
    en_title: 'English title',
    p_en_title: 'Please enter the English title',
    fayan_type: 'Speech form',
    p_fayan_type: 'Please select the speech form',
    filter_paper: 'Filterable papers',
    added: 'Added',
    not_added: 'Not added',
    added_num: 'Added {num} times',
    paper_id: 'Topic ID',
    paper_title: 'Title',
    speaker: 'Speaker',
    unit: 'Unit',
    phone: 'Phone',
    no_query_paper: 'If no paper manuscript information is found, please click',
    new: 'New',
    wait_to_add: 'To be added',
    child_session_management: 'Child session management'
};
